import React from "react"
import Icon from "../components/icon"

export const pageTitle = "Estate wide air quality reporting with confidence"
export const pageMetadata =
  "Keep an eye on air quality and other key indicators throughout your estate and know you’re providing a safe environment for your building users. pushfusion enables you to report on air quality performance for your entire organization with confidence."

export const title = "Give your building"
export const subtitle = "users confidence"
export const description = [
  {
    bold: false,
    text: (
      <>
        The buildings in your estate are full of common pollutants; as a result,
        your indoor air quality can suffer and your building users could feel
        concerned for their health. Let{" "}
        <span className="text-blue-50 font-bold">push</span>
        <span className="text-pushfusion font-extrabold">fusion</span> recover
        the data from sensors across your estate allowing you to identify areas
        where air quality is a concern.
      </>
    ),
  },
]

export const features = [
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="air-quality"
      />
    ),
    name: (
      <h3 className="text-lg font-bold text-gray-700">
        CO<sub>2</sub>
      </h3>
    ),
    description:
      "Harmless in small quantities, when CO2 levels rise too high, they can cause drowsiness, fatigue, and poor decision-making.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="occupancy"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Occupancy</h3>,
    description:
      "Have visibility into what’s really happening in your estate, from staying compliant with occupancy limits, to preventing overcrowding.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="humidity"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Humidity</h3>,
    description:
      "When there's too much humidity, allergies and cold symptoms can get worse. Low humidity makes people more susceptible to respiratory illness or even static electricity.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="thermometer"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Temperature</h3>,
    description:
      "Indoor temperatures can wreak havoc on productivity, mood, and comfort level. Poor indoor air quality is also linked to employee inefficiency.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="mould"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">Biotoxins</h3>,
    description:
      "Dangerous particulates are a health hazard in all environments, but early intervention can help prevent its growth and keep your estate healthy.",
  },
  {
    icon: (
      <Icon
        className="h-16 w-16 text-blue-50"
        aria-hidden="true"
        color="#0E98FA"
        icon="voc"
      />
    ),
    name: <h3 className="text-lg font-bold text-gray-700">VOC</h3>,
    description:
      "Toxins and chemicals in the air? The chemicals emitted by everyday items like cleaners and solvents can cause minor issues like throat irritations and more severe conditions.",
  },
]
